export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UiInput.vue?vue&type=template&id=45fc8938&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/UiInput.vue?vue&type=template&id=45fc8938&
// module id = 1094
// module chunks = 0